/** Reports Overview location filter — reporter IP geo, not Connect country. */

const COUNTRY_LABELS: Record<string, string> = {
  AU: 'Australia',
  US: 'United States',
  GB: 'United Kingdom',
  CA: 'Canada',
  NZ: 'New Zealand',
};

export const REPORTS_LOCATION_FILTER_DETAIL =
  'Reporter location (report-time IP) · not Connect country';

export function reportsCountryLabel(code: string): string {
  const upper = code.toUpperCase();
  if (COUNTRY_LABELS[upper]) return COUNTRY_LABELS[upper];
  try {
    const name = new Intl.DisplayNames(['en'], { type: 'region' }).of(upper);
    if (name && name !== upper) return name;
  } catch {
    // Fall through to the ISO code when Intl has no English name.
  }
  return upper;
}

/** Pass-through of API location codes (ISO country and `AU:VIC` state keys). */
export function reportsLocationCodes(availableCodes: readonly string[] = []): string[] {
  return [
    ...new Set(availableCodes.map((code) => code.trim().toUpperCase()).filter(Boolean)),
  ].filter((code) => code !== 'UNASSIGNED' && !isLocalhostGeoJunk(code));
}

/** MaxMind / ipinfo can map loopback oddly — never show in the picker. */
function isLocalhostGeoJunk(code: string): boolean {
  return code === 'SE' || code === 'SE:S' || code === 'SE:E';
}
